// in render.com host
// export const BASE_URL = 'http://localhost:5000';
export const BASE_URL = `https://manufacturer-api.onrender.com`;